export function isValidOtp(code: string): boolean {
  return /^[0-9]{6,8}$/.test(code.trim());
}

